import { Ultra24HeroSection } from "./Ultra24HeroSection";

/**
 * Renders Hero and Overview within a single shared background container
 * so both sections appear visually seamless.
 */
export const Ultra24HeroOverviewBlock = () => {
  return (
    <div
      className="relative"
      style={{
        backgroundImage: "url('/bg/bg3.jpg')",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-t from-red-900/100 to-red-900/80 z-0"></div>
      <Ultra24HeroSection />
    </div>
  );
};
